<template>
  <div class="login">
    <img class="logo" alt="logo beyblade" src="@/assets/imgs/bey-logo-white.webp" />

    <h1>Login</h1>

    <form @submit.prevent="login">
      <input v-model="email" type="email" placeholder="Email" required />
      <input v-model="password" type="password" placeholder="Password" required />
      <button type="submit" class="btn btn-primary" :disabled="isLoading">
        {{ isLoading ? 'Loading...' : 'Accedi' }}
      </button>
      <p v-if="error" class="error">{{ error }}</p>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { authService } from '@/services/authService'

const router = useRouter()
const email = ref('')
const password = ref('')
const error = ref('')
const isLoading = ref(false)

const login = async () => {
  error.value = ''
  try {
    isLoading.value = true
    await authService.loginWithEmail(email.value, password.value)
    
    // User creation/check is handled by UserStore when it detects auth change
    router.push('/') 
    isLoading.value = false
  } catch (err) {
    error.value = 'Credenziali errate o utente non esistente'
    console.error(err)
    isLoading.value = false
  }
}
</script>

<style scoped lang="scss">
.login {
  max-width: 300px;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.error {
  color: red;
}

form {
  display: flex;
  flex-direction: column;
  gap: 24px;

  input {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
  }
}

img.logo {
  width: 100%;
  height: auto;
  margin-bottom: 20px;
}
</style>
